import {
  IEvent,
  TealiumEventNames,
  TealiumEventCategory,
  playerStateManager,
  PlayerStatus,
  VolumeEventLabel,
} from '@4tn/core-audio-player-shared';
import { trackLink } from '../trackLink';
import { TealiumEvent } from '../../tealium-event';

// We are dispatching the system stop event only when the Triton stream is muted (The player dispatches this event conditionally).
export const streamMuteStopTealiumEventHandler = (event: IEvent) => {
  const { mediaMetadata, playerVersion } = playerStateManager.getState();

  const tealiumEvent = new TealiumEvent({
    eventName: TealiumEventNames.PLAYER_STOP,
    eventCategory: TealiumEventCategory.PLAYER,
    eventLabel: VolumeEventLabel.MUTE,
    media: {
      mediaOffset: event.time,
    },
    player: {
      playerState: PlayerStatus.MUTE,
      playerVersion,
    },
    mediaMetadata,
  });
  trackLink(tealiumEvent.getEventData());
};
